export interface Model {
  id: string;
  name: string;
}

interface ModelList {
  readonly modelList: readonly Model[];
}

export const modelList: ModelList = {
  modelList: [
    { id: 'claude-3.5-haiku', name: 'Claude 3.5 Haiku' },
    { id: 'claude-4-opus', name: 'Claude 4 Opus' },
    { id: 'claude-4-sonnet', name: 'Claude 4 Sonnet' }
  ]
};
